import { v4 as uuidv4 } from "uuid";
import { GlobalScope } from "./campaign-tracker";

const cookieDomain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN as string;

const getCookie = (name: string) => {
    try {
        const cookieArray = document.cookie.split(";");
        const cookieName = `${name}=`;

        for (let cookie of cookieArray) {
            cookie = cookie.trim();
            if (cookie.indexOf(cookieName) === 0) {
                const cookieParsedValue = JSON.parse(cookie.split("=")[1]);
                return cookieParsedValue;
            }
        }
        return null;
    } catch (e) {
        return null;
    }
};

const setCookieStorage = (name: string, value: any, expirationDays?: number) => {
    if (!Object.keys(value).length) {
        return;
    }

    const expireData = new Date(new Date().getTime() + (expirationDays ?? 30) * 60 * 24 * 60 * 1000);

    if (!cookieDomain) {
        console.warn("Cookie domain is not set");
        return;
    }
    console.log("cookies settings");
    document.cookie = `${name}=${JSON.stringify(value)};expires=${expireData};domain=${cookieDomain};path=/`;
};

export const pushUserIdToGTM = (): string => {
    let userId = getCookie("userId");

    if (!userId) {
        userId = uuidv4();
        setCookieStorage("userId", userId, 30);
    }

    const ampId = getCookie("ampId");

    if (!ampId) {
        setCookieStorage("ampId", userId, 30);
    }

    if (typeof GlobalScope !== "undefined" && "dataLayer" in GlobalScope) {
        (GlobalScope as any).dataLayer.push({
            event: "userId",
            user_id: userId,
            amp_id: ampId,
        });
    }
    return userId;
};
